import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

function Toast({ message, type = 'info', onClose }) {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  let bg = 'bg-gray-800 text-white';
  if (type === 'success') bg = 'bg-green-500 text-white';
  if (type === 'error') bg = 'bg-red-500 text-white';
  if (type === 'info') bg = 'bg-blue-500 text-white';

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 px-6 py-3 rounded-lg shadow-lg font-semibold ${bg}animate-fade-in `}
      role="alert"
      aria-live="polite"
    >
      {message}
      <button
        onClick={onClose}
        className="ml-4 text-white/80 hover:text-white font-bold text-lg"
        aria-label="Close"
      >
        &times;
      </button>
    </div>
  );
}

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.string,
  onClose: PropTypes.func,
};

export default Toast;
